/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import Compiled, { placeholderCSS as compiledPlaceholderCSS } from '../compiled/components/placeholder';
import Emotion, { placeholderCSS as emotionPlaceholderCSS } from '../emotion/components/placeholder';
export var placeholderCSS = function placeholderCSS(props) {
  return fg('compiled-react-select') ? compiledPlaceholderCSS() : emotionPlaceholderCSS(props);
};
var Placeholder = function Placeholder(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(Compiled, props) : /*#__PURE__*/React.createElement(Emotion, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Placeholder;